module.exports = __webpack_public_path__ + "static/media/termopary6ru.d6dbd4de.pdf";